import { memo } from 'react';
import { UmbracoTypes } from '~/lib/data-contract';
import { useRecentResults } from '~/services/loop54/hooks';
import { CarouselWithItems } from './helpers';

function M30RecentlyViewedProductCarousel({
    headline,
}: Omit<UmbracoTypes.IM30RecentProductCarouselModule, 'type'>) {
    const { data } = useRecentResults();

    return <CarouselWithItems data={data?.results?.items} headline={headline} />;
}

export default memo(M30RecentlyViewedProductCarousel);
